import { ApiDomainResponse, ApiDomainStatus } from "@incendium/api";
import { isWwwDomain } from "Helpers/urls";
import { getSelectedEnvironment } from "config";

export const getRootDomain = (url: string) => {
  const domain = new URL(url).hostname;
  const domainWithoutSubdomain = domain.replace("www.", "");
  return domainWithoutSubdomain;
};
export const getDomain = (url: string) => {
  return new URL(url).hostname;
};
export const getScheme = (url: string) => {
  return new URL(url).protocol;
};

export const buildFqdn = (domainUrl: string, subdomain: string): string => {
  const hostname = getDomain(domainUrl);
  return [...subdomain.split("."), ...hostname.split(".")].join(".");
};

export const getCloudflareCnameValue = (): string => {
  const host = window.location.host;
  if (host.includes("localhost")) {
    return "localhost:9091";
  }
  const env = getSelectedEnvironment();
  if (env) {
    return `api.${env}.incendium.ai`;
  }
  return "api.incendium.ai";
};

export const sortDomainsByWwwThenName = (
  a: { domain?: string },
  b: { domain?: string },
): number => {
  const aDomain = a.domain || "";
  const bDomain = b.domain || "";
  const aIsWww = isWwwDomain(aDomain);
  const bIsWww = isWwwDomain(bDomain);
  if (aIsWww === bIsWww) {
    return aDomain.localeCompare(bDomain);
  }
  return aIsWww ? 1 : -1;
};

export const getSelectableSubdomains = (
  subdomains: ApiDomainResponse[],
): ApiDomainResponse[] =>
  subdomains
    .filter(
      (sd) => sd.status !== ApiDomainStatus.DOMAIN_STATUS_DELETING,
    )
    .sort(sortDomainsByWwwThenName);

export const getLatestLiveSubdomain = (
  subdomains: ApiDomainResponse[],
): ApiDomainResponse | undefined => {
  const live = subdomains.filter(
    (sd) => sd.status === ApiDomainStatus.DOMAIN_STATUS_READY,
  );
  if (live.length === 0) {
    return undefined;
  }
  return [...live].sort((a, b) => {
    const aTime =
      a.readyAt?.getTime() ?? a.createdAt?.getTime() ?? a.id ?? 0;
    const bTime =
      b.readyAt?.getTime() ?? b.createdAt?.getTime() ?? b.id ?? 0;
    return bTime - aTime;
  })[0];
};

export const getSubdomainStatusText = (
  status: ApiDomainStatus,
  isCloudflare: boolean,
) => {
  switch (status) {
    case ApiDomainStatus.DOMAIN_STATUS_NONE:
      return isCloudflare ? "Creating CNAME" : "Creating Certificate";
    case ApiDomainStatus.DOMAIN_STATUS_CERTIFICATE_PENDING:
      return isCloudflare
        ? "CNAME awaiting validation"
        : "Certificate awaiting validation";
    case ApiDomainStatus.DOMAIN_STATUS_DOMAIN_PENDING:
      return isCloudflare
        ? "CNAME awaiting validation"
        : "Domain awaiting validation";
    case ApiDomainStatus.DOMAIN_STATUS_READY:
      return "Live";
    case ApiDomainStatus.DOMAIN_STATUS_DELETING:
      return "Deleting - We are working on it.";
  }
};
